import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Container,
  SxProps,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CustomDialog from "../custom-dialog/CustomDialog";
import { useState } from "react";
import Pricing from "./Pricing";
import ContactDetails from "./ContactDetails";

interface NavigationBarProps {
  scrollToSection: (ref: React.RefObject<HTMLDivElement>) => void;
  refs: {
    second: React.RefObject<HTMLDivElement>;
    service: React.RefObject<HTMLDivElement>;
    fourth: React.RefObject<HTMLDivElement>;
  };
}

const TYPOGRAPHY_SX: SxProps = {
  cursor: "pointer",
  color: "grey",
  "&:hover": {
    color: "black",
  },
  fontSize: { xs: "1rem", md: "1.2rem" },
  fontWeight: "bold",
  transition: "color 0.3s",
};

const NavigationBar: React.FC<NavigationBarProps> = ({
  scrollToSection,
  refs,
}) => {
  const [openPricing, setOpenPricing] = useState(false);
  const [openContactDetails, setOpenContactDetails] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const navItems = [
    { text: "O Nas", action: () => scrollToSection(refs.second) },
    { text: "Usługi", action: () => scrollToSection(refs.service) },
    { text: "Czy Warto", action: () => scrollToSection(refs.fourth) },
    { text: "Cennik", action: () => setOpenPricing(true) },
    { text: "Kontakt", action: () => setOpenContactDetails(true) },
  ];

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setDrawerOpen(open);
  };
  
  return (
    <AppBar
      position="absolute"
      style={{ background: "transparent", boxShadow: "none" }}
    >
      <Container maxWidth="md">
        <Toolbar>
          {isMobile ? (
            <>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={toggleDrawer(true)}
                sx={{ color: 'grey' }}
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="left"
                open={drawerOpen}
                onClose={toggleDrawer(false)}
              >
                <Box
                  sx={{ width: 250 }}
                  role="presentation"
                  onClick={toggleDrawer(false)}
                  onKeyDown={toggleDrawer(false)}
                >
                  <List>
                    {navItems.map((item, index) => (
                      <ListItem button key={index} onClick={item.action}>
                        <ListItemText primary={item.text} />
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Drawer>
            </>
          ) : (
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              {navItems.map((item, index) => (
                <Typography
                  key={index}
                  variant="h6"
                  sx={TYPOGRAPHY_SX}
                  onClick={item.action}
                >
                  {item.text}
                </Typography>
              ))}
            </Box>
          )}
        </Toolbar>
      </Container>
      <CustomDialog
        open={openContactDetails}
        onClose={() => setOpenContactDetails(false)}
        title="Dane Kontaktowe"
        body={<ContactDetails />}
      />
      <CustomDialog
        open={openPricing}
        onClose={() => setOpenPricing(false)}
        title="Cennik"
        body={<Pricing />}
      />
    </AppBar>
  );
};

export default NavigationBar;
